import React from "react";
import { Pane } from "evergreen-ui";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getMomentTimeObj1 } from "../util";

const TimePicker = (props) => {

  return (
    <Pane>
      <DatePicker
        className={"time-picker"}
        disabled={props.disabled}
        onChange={(e) => {
          props.timeChange(e);
        }}
        selected={getMomentTimeObj1(props.value)}
        showTimeSelect
        showTimeSelectOnly
        timeIntervals={15}
        dateFormat={"h:mm aa"}
      />
    </Pane>
  );
};

export default TimePicker;
